import { Injectable } from '@angular/core';
import { SignalrMessageType } from '@epicuro-next/constants/platform/signalr';
import { SignalRService } from '@epicuro-next/data/signalr';
import { initSignalrConnectionSuccess } from '@epicuro-next/state/signalr-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import {
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

import { AnalyticsSignalREvent } from '../../models/signalr-events';
import { reportDataReceived } from '../analytics-entities.actions';
import { analyticsListEvents } from '../constants';
import { selectCanSeeAnalytics } from '../selectors/analytics-entities.selectors';

@Injectable()
export class AnalyticsSignalrEffects {
  private canSeeAnalytics$ = this.store.pipe(
    select(selectCanSeeAnalytics),
    distinctUntilChanged(),
  );

  public onListReportEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initSignalrConnectionSuccess),
      withLatestFrom(this.canSeeAnalytics$),
      filter(([, canSeeAnalytics]) => {
        return isNonNullish(canSeeAnalytics) && canSeeAnalytics;
      }),
      switchMap(() =>
        this.signalrService.messages<[AnalyticsSignalREvent, string]>(
          SignalrMessageType.OnReportData,
        ),
      ),
      filter(([event]) => {
        return analyticsListEvents.indexOf(event) > -1;
      }),
      map(([eventName, value]) => {
        let payload;

        try {
          payload = JSON.parse(value);
        } catch {
          payload = null;
        }
        return reportDataReceived({
          event: {
            eventName,
            payload,
          },
        });
      }),
    ),
  );
  constructor(
    private actions$: Actions,
    private store: Store,
    private signalrService: SignalRService,
  ) {}
}
